var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZbritje(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.479,
    height: 19.592,
    viewBox: "0 0 28.479 19.592",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6479",
    "data-name": "Group 6479",
    transform: "translate(-489.897 -795.825)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9141",
    "data-name": "Path 9141",
    d: "M1248.574,216.339h-5.236v-2.606a.467.467,0,0,0-.467-.467h-5.2v-2.624a.467.467,0,0,0-.467-.467h-5.236V207.55a.467.467,0,0,0-.467-.467h-5.236v-2.624a.467.467,0,0,0-.467-.467h-5.235V219.43h28.479v-2.624a.467.467,0,0,0-.467-.467",
    transform: "translate(-730.664 595.986)",
    fill: "#ea3943"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9142",
    "data-name": "Path 9142",
    d: "M1933.145,60.145a.749.749,0,0,0,.36-.092l2.42-1.321a.753.753,0,0,0,.381-.533l.306-1.772.01.02.941,1.824.787,4.327a.754.754,0,0,0,.741.619.743.743,0,0,0,.136-.012.753.753,0,0,0,.607-.876l-.807-4.438a.753.753,0,0,0-.072-.211l-.827-1.6.257-2.851.274.326v-.009l1.639,1.965a.584.584,0,1,0,.9-.748l-2.405-2.883a1.639,1.639,0,0,0-.816-1.278,1.837,1.837,0,1,0-.85-.217,1.76,1.76,0,0,0-1.535,1.131c-.438.9-.884,1.8-1.315,2.7l-.885,1.78a.584.584,0,1,0,1.046.52l.807-1.623c-.044.47-.1.941-.138,1.411l-.221,1.282-2.1,1.147a.754.754,0,0,0,.362,1.415",
    transform: "translate(-1423.672 748.904)",
    fill: "#ea3943"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZbritje);
export default __webpack_public_path__ + "static/media/zbritje.4069d98dbf3ee87b84cfe10e001b1729.svg";
export { ForwardRef as ReactComponent };